<template>
    <v-dialog v-model="dialog" scrollable max-width="600px" hide-overlay>
        <template v-slot:activator="{ on }">
            <v-btn color="secondary" small icon v-on="on">
                <v-tooltip bottom color="primary">
                    <template v-slot:activator="{ on }">
                        <v-icon small v-on="on">mdi-pencil</v-icon>
                    </template>
                    <span>edit game</span>
                </v-tooltip>
            </v-btn>
        </template>
        <v-card v-if="!loading">
            <v-card-title class="subtitle-2 pt-6">
                New parameters for game {{game.id }} 
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="black--text">
                <v-container grid-list-md>
                    <v-form v-model="valid" ref="form" lazy-validation>
                        <v-row>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="current round" v-model.number="round"
                                    name="round" type="text" :rules="[rules.number]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                                <v-textarea outlined dense color="primary" 
                                    label="description"
                                    v-model="description" name="description"
                                    :rules="[rules.required]" 
                                    @change="onceMore()">
                                </v-textarea>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
                <v-row justify="center" class="error">{{ error }}</v-row>
                <v-row justify="center" class="subtitle-2">{{ message }}</v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text class="text-capitalize" :disabled="Boolean(error)"
                    @click="editGame">
                    Save
                </v-btn>
                <v-btn color="primary" text class="text-capitalize" @click="closeDialog">
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    name: 'EditGame',
    props: ['game'],
    data() {
        return {
            dialog: false,
            valid: false,
            error: '',
            message: '',
            rules: {
                required: v => !!v || 'this field is required',
                number: v => /^[+]?[0-9]/.test(v) || 'it\'s expected number',
            },
            round: this.game.round,
            description: this.game.description,

        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
    },
    methods: {
        onceMore() {
            this.error = '';
            this.message = '';
        },
        async editGame() {

            if (this.$refs.form.validate()) {

                const game = {
                    /* gameId: this.gameId,
                    round: this.round,
                    productId: this.product.productId,teamId: this.product.team.id, */
                    id: this.game.id,
                    round: this.round,
                    description: this.description,
                }
                console.log(game)
                try {
                    /* edit game */
                    await this.$store.dispatch('updateGame', game)
                    this.closeDialog()
                }
                catch (error) {
                    this.$store.dispatch('setError', error.message)//throw error
                }
            } 
        },
        closeDialog() {
            //reset
            this.dialog = false;
            this.error = '';
        }
    },    
}
</script>